import React from 'react';
import { X } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === 'error' ? 'bg-red-500' : type === 'warning' ? 'bg-yellow-500' : 'bg-green-500';

  // Ensure message is always a string
  const displayMessage = typeof message === 'string' 
    ? message 
    : typeof message === 'object' && message !== null
    ? JSON.stringify(message)
    : String(message);

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom">
      <div className={`${bgColor} text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 max-w-md`}>
        <div className="w-2 h-2 rounded-full bg-white animate-pulse" />
        <span className="flex-1">{displayMessage}</span>
        <button onClick={onClose} className="hover:bg-white/20 rounded p-1">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
